import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMob = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M17.216.704q.825 0 1.412.587.588.588.588 1.413v3.1q.45.175.724.55.276.375.276.85v2q0 .475-.276.85-.274.375-.724.55v10.1q0 .825-.588 1.412a1.93 1.93 0 0 1-1.412.588h-10q-.826 0-1.413-.588a1.93 1.93 0 0 1-.588-1.412v-18q0-.825.588-1.413A1.93 1.93 0 0 1 7.216.704zm-10 20h10v-18h-10zm5-17q.424 0 .712.287.287.288.288.713 0 .424-.288.712a.97.97 0 0 1-.712.288.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712q0-.425.287-.713a.97.97 0 0 1 .713-.287",
		clipRule: "evenodd"
	})
});
export default SvgMob;
